module.exports = __webpack_public_path__ + "media/country_flags/gi-13c789eb.png";